import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { Box, Grid, MenuItem, styled, Typography } from "@mui/material";

import DrawerCustom from "../../../../shared/general/Drawer";
import { Controller, useForm } from "react-hook-form";
import TextFieldTheme from "../../../../shared/general/TextFieldTheme";
import ButtonBlue from "../../../../shared/general/ButtonBlue";
import { openNotificationAlert } from "../../../../../../actions/notificationAlert";
import { getEmployeeProfile } from "../../../../../../actions/employee";
import { updateUser } from "../../../../../../actions/user";

import * as yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";

const StyledRoot = styled(Box)({
  padding: "16px",
})

const DrawerEditPaymentRound = (props) => {

  const { drawerConfig, handleClose } = props;
  const dispatch = useDispatch();
  const { t, i18n } = useTranslation();

  const { result: employeeProfile } = useSelector((state) => state.employeeProfile);
  const { result: userProfile } = useSelector((state) => state.userProfile);

  const validationSchema = yup.object({
    roundPayment: yup.string().required(`${t("ThisFieldIsRequired")}`),
  });

  const useHookForm = useForm({
    defaultValues: {
      roundPayment: "",
    },
    resolver: yupResolver(validationSchema),
    mode: "all",
  })

  const onSubmit = async (data) => {

    const formData = {
      roundPayment: data.roundPayment === ""? null: data.roundPayment,
      idEmp: employeeProfile.idEmp,
      UpdateBy: userProfile.idUsers,
    }

    const result = await dispatch(updateUser(formData));
    
    if(result && result.status === 200) {
      handleClose();
      dispatch(openNotificationAlert({
        type: "success",
        message: t("DataSaveSuccessful"),
      }));
      dispatch(getEmployeeProfile(employeeProfile.idEmp));
    } else {
      dispatch(openNotificationAlert({
        type: "error",
        message: t("AnErrorOccurred")
      }));
    }

  }

  useEffect(() => {
    if(drawerConfig.isOpen){
      useHookForm.reset({
        roundPayment: employeeProfile.roundPayment? employeeProfile.roundPayment: "",
      })
    }
  }, [drawerConfig.isOpen])

  return (
    <DrawerCustom
      title={t("PaymentRound")}
      anchor={"right"}
      open={drawerConfig.isOpen}
      onClose={handleClose}
      PaperProps={{
        sx: {
          width: "100%",
          maxWidth: "500px",
        },
      }}
    >
      <StyledRoot>
        <form onSubmit={useHookForm.handleSubmit(onSubmit)}>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <Typography fontSize="14px" color="text.secondary" paddingBottom={1}>{t("PaymentRound")}</Typography>
              <Controller
                name="roundPayment"
                control={useHookForm.control}
                render={({field, fieldState}) => (
                  <TextFieldTheme
                    {...field}
                    select
                    error={fieldState.error? true: false}
                    helperText={fieldState.error? fieldState.error.message: null}
                  >
                    <MenuItem value="1">1</MenuItem>
                    <MenuItem value="2">2</MenuItem>
                    <MenuItem value="3">3</MenuItem>
                    <MenuItem value="4">4</MenuItem>
                  </TextFieldTheme>
                )}
              />
            </Grid>

            <Grid item xs={12} container justifyContent="space-between">
              <ButtonBlue className="cancel" onClick={handleClose}>
                {t("Cancel")}
              </ButtonBlue>
              <ButtonBlue
                variant="contained"
                type="submit"
              >
                {t("Save")}
              </ButtonBlue>
            </Grid>
          </Grid>
        </form>
      </StyledRoot>
    </DrawerCustom>
  )
}

export default DrawerEditPaymentRound;